var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$oidc && _vm.$oidc.userProfile && _vm.$oidc.userProfile.isAuthenticated)?_c('Header'):_vm._e(),(_vm.$oidc && _vm.$oidc.userProfile && _vm.$oidc.userProfile.isAuthenticated)?_c('router-view'):_vm._e(),(_vm.$oidc && _vm.$oidc.userProfile && _vm.$oidc.userProfile.isAuthenticated)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }